/* Erevotech: marks the homepage hero video backdrop image as explicitly
   decorative (alt="") for accessibility/SEO completeness. This image sits
   behind real heading/subheading text that already conveys the same
   information, so it should not carry redundant alt text — but leaving
   the alt attribute off entirely (rather than empty) can still be flagged
   by audits as "missing alt". This sets it explicitly. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.slideshow-backdrop-image').forEach(function (img) {
      if (!img.hasAttribute('alt') || img.getAttribute('alt') === null) {
        img.setAttribute('alt', '');
      }
    });
  });
})();
